
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const LearnMore = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative h-[300px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d"
          alt="Learn More Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
            Discover Dynamico
          </h1>
        </div>
      </div>

      {/* Features Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900">
              Digital Transformation Made Easy
            </h2>
            <p className="text-lg text-gray-600">
              Dynamico is your partner in digital transformation, offering a comprehensive platform that helps businesses streamline their operations and embrace the digital age.
            </p>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">No-Code Platform</h3>
                  <p className="text-gray-600">Build and customize your digital solutions without any coding knowledge.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Workflow Automation</h3>
                  <p className="text-gray-600">Automate repetitive tasks and streamline your business processes.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Asset Management</h3>
                  <p className="text-gray-600">Track and manage your digital assets efficiently.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative h-[400px]">
            <img
              src="https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7"
              alt="Digital Transformation"
              className="w-full h-full object-cover rounded-lg shadow-xl"
            />
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Why Choose Dynamico?
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-6 bg-gray-50 rounded-lg">
              <h3 className="font-semibold text-xl text-gray-900 mb-4">Rapid Implementation</h3>
              <p className="text-gray-600">Quick setup and deployment of your digital solutions with minimal effort.</p>
            </div>
            <div className="p-6 bg-gray-50 rounded-lg">
              <h3 className="font-semibold text-xl text-gray-900 mb-4">Scalable Solutions</h3>
              <p className="text-gray-600">Grow your digital infrastructure alongside your business needs.</p>
            </div>
            <div className="p-6 bg-gray-50 rounded-lg">
              <h3 className="font-semibold text-xl text-gray-900 mb-4">24/7 Support</h3>
              <p className="text-gray-600">Round-the-clock assistance to ensure your operations run smoothly.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-primary/10 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Ready to Transform Your Business?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Join countless businesses that have already revolutionized their operations with Dynamico.
          </p>
          <Button 
            onClick={() => {
              navigate("/request-demo");
              window.scrollTo(0, 0);
            }}
            className="bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
          >
            Request a Demo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LearnMore;
